import { Building2, Mail, ShieldCheck, UserRound } from 'lucide-react';
import { motion } from 'framer-motion';
import { useAuth } from '@/auth/AuthContext';

const ROLE_LABELS: Record<string,string> = {ADMIN:'Administrador geral',TECHNICAL_ADMIN:'Administrador técnico',TECHNICAL:'Técnico de TI',VIEWER:'Somente relatórios',SYSTEM_EXTERNAL:'Sistema Externo'};

export default function ProfilePage() {
    const { user, activeSecretary } = useAuth();
    if (!user) return null;

    const details = [
        { label: 'Nome', value: user.name, icon: UserRound },
        { label: 'E-mail', value: user.email, icon: Mail },
        { label: 'Perfil de acesso', value: ROLE_LABELS[user.role] ?? user.role, icon: ShieldCheck },
        { label: 'Equipe de TI', value: activeSecretary?.itTeam?.name ?? 'Não selecionada', icon: Building2 },
        { label: 'Secretaria ativa', value: activeSecretary?.name ?? 'Não selecionada', icon: Building2 },
    ];

    return (
        <section className="page-content mx-auto max-w-4xl">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                {details.map(({ label, value, icon: Icon }, index) => (
                    <motion.div
                        key={label}
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.06 }}
                        whileHover={{ y: -3 }}
                        className="ui-card ui-card-hover"
                    >
                        <div className="flex items-center gap-3 text-blue-400">
                            <Icon size={19} />
                            <span className="text-[10px] font-black uppercase tracking-widest text-slate-500">{label}</span>
                        </div>
                        <p className="mt-4 break-words text-sm font-bold text-slate-100">{value}</p>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
